<template>
  <div class="post-common">
    <div
      class="post-common-list"
      v-loading="loadAttendance"
      v-if="loadAttendance"
    ></div>
    <ul class="post-common-list" v-if="!loadAttendance">
      <li class="post-common-list__item">
        <span class="post-common-list__item-number">
          {{ totalSource }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ periodName }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('1') != -1) &&
          selectedSocial.some((item) => item.indexOf('Vkontakte') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ vk }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.vk") }}
          </span>
        </div>
      </li>

      <!--<li class="post-common-list__item" v-if="socialOptions.some((item) => item.value.indexOf('11') != -1) && selectedSocial.some((item) => item.indexOf('Блоги') != -1)">
          <span class="post-common-list__item-number">
            {{dz}}
          </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
              {{$t('feed.postCommon.dz')}}
            </span>
        </div>
      </li>-->

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('3') != -1) &&
          selectedSocial.some((item) => item.indexOf('Facebook') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ fb }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.fb") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('2') != -1) &&
          selectedSocial.some((item) => item.indexOf('Twitter') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ tw }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.tw") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('7') != -1) &&
          selectedSocial.some((item) => item.indexOf('Instagram') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ ig }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.ig") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('5') != -1) &&
          selectedSocial.some((item) => item.indexOf('Telegram') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ tg }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.tg") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('8') != -1) &&
          selectedSocial.some((item) => item.indexOf('Youtube') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ yt }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.yt") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('10') != -1) &&
          selectedSocial.some((item) => item.indexOf('Одноклассники') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ ok }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.ok") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('10') != -1) &&
          selectedSocial.some((item) => item.indexOf('Одноклассники') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ dz }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.dz") }}
          </span>
        </div>
      </li>

      <li
        class="post-common-list__item"
        v-if="
          socialOptions.some((item) => item.value.indexOf('4') != -1) &&
          selectedSocial.some((item) => item.indexOf('СМИ') != -1)
        "
      >
        <span class="post-common-list__item-number">
          {{ gs }}
        </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
            {{ $t("feed.postCommon.gs") }}
          </span>
        </div>
      </li>

      <!--li class="post-common-list__item" v-if="!loadAttendance">
          <span class="post-common-list__item-number">
            {{attendance.toLocaleString('ru-RU')}}
          </span>
        <div class="post-common-list__item-day">
          <span class="post-common-list__item-day-number-title">
              {{$t('feed.postCommon.coverage')}}
            </span>
        </div>
      </li-->
    </ul>
  </div>
</template>

<script>
// libraries
import moment from "moment/moment";

// api
import { getThreadAtTendanceApi } from "../../../../../../../api/feeds";
import {
  getPostCountLightApi,
  getPostCountApi,
} from "../../../../../../../api/stats";

export default {
  name: "PostCommon",
  props: {
    dates: {
      type: Object,
    },
    socialOptions: {
      type: Array,
    },
    selectedSocial: {
      type: Array,
    },
    selectedEndTime: {
      type: String,
    },
    selectedStartTime: {
      type: String,
    },
  },
  data() {
    return {
      statisticName: "Statistic",
      attendance: 0,
      loadAttendance: false,
      firstData: [],
      total: 0,
      vk: 0,
      fb: 0,
      tw: 0,
      tg: 0,
      gs: 0,
      yt: 0,
      ig: 0,
      ok: 0,
      dz: 0,
      feedParams: "",
    };
  },
  computed: {
    statisticData() {
      return this.$store.getters.chartData(this.statisticName);
    },
    periodName() {
      return this.$store.getters.periodName(this.statisticName, this.$i18n);
    },
    totalSource() {
      let totalSources = this.total;
      if (!this.selectedSocial.some((item) => item.indexOf("Vkontakte") != -1))
        totalSources = totalSources - this.vk;
      if (!this.selectedSocial.some((item) => item.indexOf("Telegram") != -1))
        totalSources = totalSources - this.tg;
      if (!this.selectedSocial.some((item) => item.indexOf("Блоги") != -1))
        totalSources = totalSources - this.dz;
      if (!this.selectedSocial.some((item) => item.indexOf("Facebook") != -1))
        totalSources = totalSources - this.fb;
      if (!this.selectedSocial.some((item) => item.indexOf("Twitter") != -1))
        totalSources = totalSources - this.tw;
      if (!this.selectedSocial.some((item) => item.indexOf("Instagram") != -1))
        totalSources = totalSources - this.ig;
      if (!this.selectedSocial.some((item) => item.indexOf("Youtube") != -1))
        totalSources = totalSources - this.yt;
      if (!this.selectedSocial.some((item) => item.indexOf("СМИ") != -1))
        totalSources = totalSources - this.gs;
      if (
        !this.selectedSocial.some((item) => item.indexOf("Одноклассники") != -1)
      )
        totalSources = totalSources - this.ok;
      return totalSources;
    },
  },
  methods: {
    getCoverage() {
      let startTime = this.selectedStartTime
        ? moment(this.selectedStartTime).format("HH:mm:ss")
        : "00:00:00";
      let endTime = this.selectedEndTime
        ? moment(this.selectedEndTime).format("HH:mm:ss")
        : "23:59:59";
      let from =
        moment(this.dates.date_from).format("YYYY-MM-DD") + " " + startTime;
      let to = moment(this.dates.date_to).format("YYYY-MM-DD") + " " + endTime;

      let fromR = this.$store.getters.retrospective(
        this.$route.params.threadId
      );
      let toR = this.$store.getters.retro_max(this.$route.params.threadId);

      if (fromR && toR && from > toR) from = fromR;
      if (fromR && toR && to > toR) to = toR;

      let params = {
        thread_id: Number(this.$route.params.threadId),
        need_graph: false,
        from: moment(this.dates.date_from).format("YYYY-MM-DD") + " 00:00:00",
        to: moment(this.dates.date_to).format("YYYY-MM-DD") + " 23:59:59",
      };

      this.loadAttendance = true;

      getThreadAtTendanceApi(params).then((resp) => {
        this.attendance = resp.data.attendance;
        
      });

      const params2 = {
        thread_id: Number(this.$route.params.threadId),
        from,
        to,
      };
      {
        getPostCountLightApi(params2).then((resp) => {
          this.loadAttendance = false;
          this.total = resp.data.total;
          this.vk = resp.data.vk;
          this.fb = resp.data.fb;
          this.tw = resp.data.tw;
          this.tg = resp.data.tg;
          this.yt = resp.data.yt;
          this.gs = resp.data.gs;
          this.ig = resp.data.ig;
          this.ok = resp.data.ok;
          //this.dz = resp.data.dz;
        });
      }
      //if (this.feedParams == "profiles") {
      /*else {
        getPostCountApi(params2).then((resp) => {
          //console.log('dd', resp.data.total.total)
          this.total =
            resp.data.vk.total.posts +
            resp.data.fb.total.posts +
            resp.data.tw.total.posts +
            resp.data.tg.total.posts +
            resp.data.yt.total.posts +
            resp.data.gs.total.posts +
            resp.data.ig.total.posts +
            //resp.data.dz.total.posts +
            resp.data.ok.total.posts;
          this.vk = resp.data.vk.total.posts;
          this.fb = resp.data.fb.total.posts;
          this.tw = resp.data.tw.total.posts;
          this.tg = resp.data.tg.total.posts;
          this.yt = resp.data.yt.total.posts;
          this.gs = resp.data.gs.total.posts;
          this.ig = resp.data.ig.total.posts;
          this.ok = resp.data.ok.total.posts;
          //this.dz = resp.data.dz.total.posts;
        });
      }*/
    },
    getSum(arr) {
      return arr.reduce((sum, current) => {
        return sum + current[1];
      }, 0);
    },
    getBySocial(soc) {
      if (this.statisticData[soc] !== undefined)
        return this.getSum(this.statisticData[soc].total);
      else return "0";
    },
    getFeed() {
      return this.$store.getters["feed"](this.$route.params.threadId)
        ? this.$store.getters["feed"](this.$route.params.threadId)
        : {};
    },
  },
  mounted() {
    this.feedParams = this.getFeed().threadtype;
    this.getCoverage();
    console.log("SelectedSocial", this.selectedSocial);
  },
  beforeMount() {
    this.feedParams = this.getFeed().threadtype;
  },
};
</script>

<style>
.post-common-list {
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  min-height: 50px;
  margin: 0;
  margin-bottom: 20px;
}

.post-common-list__item {
  display: flex;
  align-items: center;
}
.post-common-list__item-number {
  font-family: "Roboto", "Arial", sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #5e6d82;
}
.post-common-list__item-day {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 25px;
  margin-right: 10px;
}
.post-common-list__item-day-number {
  font-family: "Roboto", "Arial", sans-serif;
  font-weight: 500;
  font-size: 10px;
  color: #15cf49;
}
.post-common-list__item-day-number-title {
  font-family: "Roboto", "Arial", sans-serif;
  font-weight: 300;
  font-size: 10px;
  color: #b3b3b3;
}
@media screen and (max-width: 480px) {
  .post-common-list {
    overflow-x: auto;
    width: 100%;
  }
  .post-common-list__item {
    margin-right: 10px;
  }
  .post-common-list__item:last-child {
    margin-right: 0;
  }
  .post-common-list__item-number {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 500;
    font-size: 18px;
  }
  .post-common-list__item-day {
    height: unset;
  }
}
</style>
